import { lazy } from "react";
import { useFeatures } from "./featureManager";
import { environment, isTruthy } from "src/config/environment";

// webpackPrefetch idle-fetches these chunks so first navigation has no download cost; applied only to high-traffic landing routes.
const NewAskKural = lazy(() => import(/*webpackPrefetch:true */ "../pages/NewAskKural"));
const StudyPage = lazy(() => import(/* webpackPrefetch: true */ "../pages/Studies"));
const InsightPage = lazy(() => import(/* webpackPrefetch: true */ "../pages/Insights"));
const ManageStudies = lazy(() => import(/* webpackPrefetch: true */ "../pages/ManageStudies"));
const EditMetadata = lazy(() => import("../pages/EditMetadata"));
const ManageApiKey = lazy(() => import("../pages/ManageApiKey"));
const AdminCenter = lazy(() => import(/* webpackPrefetch: true */ "../pages/AdminCenter"));
const Taxanomy = lazy(() => import("../pages/Taxanomy"));
const FeatureManagement = lazy(() => import("../pages/AdminCenter/components/FeatureManagement"));
const ManageSegment = lazy(() => import("../pages/Insights/components/CustomSegment"));
const EventLog = lazy(() => import("../pages/AdminCenter/components/EventLog"));
const UserObservability = lazy(() => import("../pages/AdminCenter/components/UserObservability"));
const AddStudy = lazy(() => import(/* webpackPrefetch: true */ "../pages/AddStudy"));
const MyFeed = lazy(() => import("src/pages/MyFeed"));
const StoryBoard = lazy(() => import("src/pages/StoryBoard"));
const ReportsHomePage = lazy(() => import("src/pages/Reports"));
const CreateReportPage = lazy(() => import("src/pages/Reports/components/CreateReportPage"));
const ViewReportPage = lazy(() => import("src/pages/Reports/components/ViewReportPage"));
const MonitoringDashboard = lazy(() => import("../pages/AdminCenter/components/Monitoring"));
const TranscriptExport = lazy(() => import("../pages/AdminCenter/components/TranscriptExport"));
// const ThemeManagement = lazy(() => import("../pages/AdminCenter/components/ThemeManagement"));
const UserGuide = lazy(() => import("src/pages/UserGuide"));
const InSilicoLanding = lazy(() => import("src/pages/InSilicoLanding"));
const PersonasHome = lazy(() => import("src/pages/PersonasHome"));
const PersonaProject = lazy(() => import("src/pages/PersonaProject"));
const Setup = lazy(() => import("src/pages/Setup"));
const Chat = lazy(() => import("src/pages/Chat"));
const DTProjects = lazy(() => import("src/pages/DTProjects"));
const DTProjectDetail = lazy(() => import("src/pages/DTProjectDetail"));

const redirectPageURL = environment.REACT_APP_REDIRECT_PAGE_URL;
const redirectPageItems = redirectPageURL ? redirectPageURL.split(",").slice(0, 2) : [null, ""];

const isMonitoringAvailable = isTruthy(environment.REACT_APP_MONITORING_AVAILABLE);

export const newMenuItems = [
	{
		key: "my-feed",
		// icon: "studies",
		label: "My Feed",
		path: "/my-feed",
		// component: InsightPage,
		component: MyFeed,
		disabled: false,
		displayOnTopNavbarRadio: true,
	},
	{
		key: "studies",
		icon: "studies",
		label: "Studies",
		path: "/studies",
		component: StudyPage,
		disabled: false,
		displayOnTopNavbarRadio: true,
	},
	{
		key: "storyboard",
		// icon: "manageStudies",
		label: "Storyboard",
		path: "/storyboard",
		// component: ManageStudies,
		component: StoryBoard,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "reports",
		label: "Reports",
		path: "/reports",
		component: ReportsHomePage,
		disabled: false,
		displayOnTopNavbarRadio: true,
	},
	{
		key: "add-report",
		label: "Add Report",
		path: "/add-report",
		component: CreateReportPage,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "view-report",
		label: "View Report",
		path: "/view-report",
		component: ViewReportPage,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "askKural",
		// icon: "manageStudies",
		label: "Ask Kural",
		path: "/ask-kural",
		component: NewAskKural,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "addStudy",
		label: "Add Study",
		path: "/add-study",
		component: AddStudy,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "manageStudies",
		icon: "manageStudies",
		label: "Manage Studies",
		path: "/manage-studies",
		component: ManageStudies,
		displayOnTopNavbarRadio: false,
	},
	{
		// Single-segment routes (NOT nested under /manage-studies/:studyId) so that the
		// browser resolves relative bundle URLs against the origin root on a hard refresh.
		// A nested path made config.js/runtime.js/main.js 404 on reload. The target study
		// id lives in Redux (editMetadataSlice.studyId), set before navigation.
		key: "editMetadata",
		icon: "manageStudies",
		label: "Edit Metadata",
		path: "/edit-metadata",
		component: EditMetadata,
		displayOnTopNavbarRadio: false,
		hideOnSidebar: true,
	},
	{
		key: "viewMetadata",
		icon: "manageStudies",
		label: "View Metadata",
		path: "/view-metadata",
		component: EditMetadata,
		displayOnTopNavbarRadio: false,
		hideOnSidebar: true,
	},
	{
		key: "insights",
		icon: "insights",
		label: "Insights",
		path: "/insights",
		component: InsightPage,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "manageSegment",
		icon: "manageSegment",
		label: "Manage Segment",
		path: "/manage-segment",
		component: ManageSegment,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "taxonomy",
		icon: "taxonomy",
		label: "Manage Taxonomy",
		path: "/manage-taxonomy",
		component: Taxanomy,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "redirectToPage",
		icon: "redirectToPage",
		label: redirectPageItems[1]?.replace(/_/g, " ") || "",
		path: redirectPageItems[0] || null,
		component: null,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "help",
		icon: "help",
		label: "Help",
		path: null,
		component: null,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "user-guide",
		icon: "help",
		label: "Help",
		path: null,
		component: UserGuide,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "insilico-landing",
		label: "Insilico",
		path: "/personas",
		component: InSilicoLanding,
		disabled: false,
		displayOnTopNavbarRadio: true,
	},
	{
		key: "personas",
		label: "Chat with Personas",
		path: "/personas/projects",
		component: PersonasHome,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "persona-project",
		label: "Persona Project",
		path: "/personas/:projectId",
		component: PersonaProject,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "persona-setup",
		label: "Setup",
		path: "/personas/:projectId/:category/setup",
		component: Setup,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "persona-chat",
		label: "Chat",
		path: "/personas/:projectId/:category/chat",
		component: Chat,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "dt-projects",
		label: "Simulated MR Panel",
		path: "/dt/projects",
		component: DTProjects,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
	{
		key: "dt-project-detail",
		path: "/dt/projects/:projectId",
		component: DTProjectDetail,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
];

export const adminMenuItems = [
	{
		key: "adminCenter",
		icon: "adminCenter",
		label: "Admin Center",
		path: "/admin-center",
		component: AdminCenter,
		disabled: false,
		displayOnTopNavbarRadio: true,
		supportEnabled: true,
	},
	{
		key: "featureManagement",
		icon: "featureManagement",
		label: "Feature Management",
		path: "/feature-management",
		component: FeatureManagement,
		disabled: false,
		displayOnTopNavbarRadio: true,
		supportEnabled: true,
	},
	{
		key: "eventLogs",
		icon: "eventLogs",
		label: "Events",
		path: "/event-logs",
		component: EventLog,
		disabled: false,
		displayOnTopNavbarRadio: true,
		supportEnabled: true,
	},
	// Conditionally include monitoring
	{
		key: "monitoring",
		icon: "userActivityLogs",
		label: "Monitoring",
		path: "/monitoring",
		component: MonitoringDashboard,
		disabled: false,
		displayOnTopNavbarRadio: true,
	},
	{
		key: "transcriptExport",
		icon: "fileExport",
		label: "Transcript Export",
		path: "/transcript-export",
		component: TranscriptExport,
		disabled: false,
		displayOnTopNavbarRadio: true,
		supportEnabled: false,
	},
	// {
	// 	key: "themeManagement",
	// 	icon: "themeManagement",
	// 	label: "Theme Management",
	// 	path: "/theme-management",
	// 	component: ThemeManagement,
	// },
	{
		key: "help",
		icon: "help",
		label: "Help",
		path: null,
		component: null,
		disabled: false,
		displayOnTopNavbarRadio: false,
	},
];

export const developerMenuItems = [
	{
		key: "manageApiKey",
		icon: "manageApiKey",
		label: "Manage Keys",
		path: "/manage-api-keys",
		component: ManageApiKey,
		disabled: false,
		displayOnTopNavbarRadio: true,
		supportEnabled: true,
	},
];

export const observerMenuItems = [
	{
		key: "monitoring",
		icon: "userActivityLogs",
		label: "Monitoring",
		path: "/monitoring",
		component: MonitoringDashboard,
		disabled: false,
		displayOnTopNavbarRadio: true,
		supportEnabled: false,
	},
];
